/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Remove_Set_TitleInputs */

const en_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Set`)
};

const fr_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'ensemble`)
};

const de_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen Sie den Satz`)
};

const it_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi set`)
};

const ru_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить набор`)
};

const es_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar conjunto`)
};

const zh_cn2_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除设置`)
};

const ja_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セットを削除`)
};

const hi_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेट हटाएँ`)
};

const pt_pt2_tags_manager_remove_set_title = /** @type {(inputs: Tags_Manager_Remove_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover conjunto`)
};

/**
* | output |
* | --- |
* | "Remove Set" |
*
* @param {Tags_Manager_Remove_Set_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_set_title = /** @type {((inputs?: Tags_Manager_Remove_Set_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Set_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_remove_set_title(inputs)
	if (locale === "de") return de_tags_manager_remove_set_title(inputs)
	if (locale === "it") return it_tags_manager_remove_set_title(inputs)
	if (locale === "ru") return ru_tags_manager_remove_set_title(inputs)
	if (locale === "es") return es_tags_manager_remove_set_title(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_remove_set_title(inputs)
	if (locale === "ja") return ja_tags_manager_remove_set_title(inputs)
	if (locale === "hi") return hi_tags_manager_remove_set_title(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_remove_set_title(inputs)
	return en_tags_manager_remove_set_title(inputs)
});